<div class="text-center">

  <h1 mat-dialog-title translate> {{title}} </h1>
  <div class="modal-body" mat-dialog-content>
    <p [innerHTML]="body | translate"></p>
    
      <mat-form-field class = "full-width">
        <mat-label translate class = "mt-3"> {{deviceName_text}} </mat-label>
        <input class = "full-width" [(ngModel)] = "deviceName" matInput>
      </mat-form-field>

      <ng-container *ngIf="type == 20">
      
        <br>
        
        <mat-form-field class = "full-width">
          <mat-label translate class = "mt-3"> {{counterName_text}} </mat-label>
          <input [(ngModel)] = "counterName" matInput>
        </mat-form-field>

      </ng-container>

  </div>
  <div class="modal-footer" mat-dialog-actions translate>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
     {{cancel_text}}
    </button>
    <button type="button" class="btn btn-outline-secondary"
      (click)="continue()" translate>
      {{confirm_text}}
    </button>
  </div>
</div>